export const EMPTY_ICON = "itaufonts_institucional";
export const CHECKED_ICON = "itaufonts_full_checkbox";
export const INDETERMINATE_ICON = "itaufonts_checkbox_indeterminado";
//# sourceMappingURL=constants.js.map